import React, { memo } from 'react'

import { Icon, ImageAI } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSizeXLarge } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const loadingIcon = <Icon svgComponent={ImageAI} size={iconSizeXLarge} color="dark" notSpaced />

// Loading turn: "Creating your image..." label above a shimmering placeholder.
function GeneratingState() {
  const t = useTranslation()

  return (
    <div className="image-assistant-create-tab__generating">
      <p className="image-assistant-create-tab__generating-label cgt-body-base">
        {t('imageAssistantPanel.createTab.generatingState.label')}
      </p>
      <div className="image-assistant-create-tab__loading-card">{loadingIcon}</div>
    </div>
  )
}

export default memo(GeneratingState)
